import {
    Vue,
    VueRouter,
    VeeValidate,
    Notifications
} from './vue.bundle';

Vue.use(VueRouter);
Vue.use(VeeValidate, { events: '' });
Vue.use(Notifications);

import Welcome from './components/Welcome';
import RequestAccess from './components/RequestAccess';
import Registration from './components/Registration';
import RequestPasswordReset from './components/RequestPasswordReset';
import PasswordReset from './components/PasswordReset';
import NotificationAnon from './components/NotificationAnon';

const routes = [
    {
        name: 'default',
        path: '/',
        components: {
            default: Welcome
        }
    },
    {
        name: 'requestAccess',
        path: '/requestaccess',
        components: {
            default: RequestAccess
        }
    },
    {
        name: 'registrationInvalid',
        path: '/registration',
        redirect: '/'
    },
    {
        name: 'registration',
        path: '/registration/:token',
        components: {
            default: Registration
        }
    },
    {
        name: 'requestPasswordReset',
        path: '/requestpasswordreset',
        components: {
            default: RequestPasswordReset
        }
    },
    {
        name: 'passwordResetInvalid',
        path: '/passwordreset',
        redirect: '/'
    },
    {
        name: 'passwordReset',
        path: '/passwordreset/:token',
        components: {
            default: PasswordReset
        }
    },
    {
        name: 'notificationDetails',
        path: '/notifications/:guid',
        components: {
            default: NotificationAnon
        }
    },
    { path: '/home', redirect: '/' }
];

const router = new VueRouter({
    routes: routes
});


new Vue({
    router,
    methods: {
        hashChangeHandler: function () {
            var target = window.location.hash;
            this.$router.push(target.substring(1, target.length));
        }
    },
    mounted: function () {
        // fix for IE 11
        if (!!window.MSInputMethodContext && !!document.documentMode) {
            window.addEventListener('hashchange', this.hashChangeHandler);
        }
    },
    destroyed: function () {
        // fix for IE 11
        if (!!window.MSInputMethodContext && !!document.documentMode) {
            window.removeEventListener('hashchange', this.hashChangeHandler);
        }
    } 

}).$mount("#app");


// WEBPACK FOOTER //
// ./src/scripts/vue/public.js